import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Select from "react-select";
import customStyles from "../../../../customstyle/customstyle";
import ErrorModal from "../../../../reusableComponents/ErrorModal";
import {country} from "../../../../utils/constants/country";
import SuccessModal from "../../../reusableComponents/SuccessModal";
import AccountPassword from "../AccountPassword";
import "./style.scss";
import {clearPersistedData} from "../../../../store/configureStore";
import {deAuthenticate} from "../../../../store/reducers/authSlice";
import {updateUserDetailsRequest} from "../../../../utils/apis";
import {getUser} from "../../../../store/reducers/userSlice";
import {PURGE_Brand} from "../../../../store/reducers/brandSlice";
import {returnMessages} from "../../../../store/reducers/message";

function AccountDetails({userDetails, editModes, setEditMode, disabledInputs}) {
  const idToken = useSelector((state) => state.auth.idToken);
  const dispatch = useDispatch();

  const hasUserDetails = userDetails && Object.keys(userDetails).length > 0;
  const [editMode, setLocalEditMode] = useState(false); // Start in view mode

  const handleEditMode = () => {
    setEditMode(!editMode);
    setLocalEditMode(!editMode);
  };

  const options = country.map((item) => ({
    value: item.country,
    label: item.country,
  }));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [countryName, setCountryName] = useState({
    label: userDetails?.country || "",
    value: userDetails?.country || "",
  });

  const [formData, setFormData] = useState({
    first_name: userDetails?.first_name || "",
    last_name: userDetails?.last_name || "",
    contact: userDetails?.contact || "",
    email: userDetails?.email || "",
    country: userDetails?.country || countryName?.value,
    city: userDetails?.city || "",
    country_code: userDetails?.country_code || "",
  });

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      country: countryName?.value,
    }));
  }, [countryName]);

  const [isSpinner, setIsSpinner] = useState(false);
  const [inputErrors, setInputErrors] = useState({
    email: "",
    contact: "",
  });

  const handleChange = (e) => {
    const {name, value} = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCountryChange = (selectedOption) => {
    setCountryName(selectedOption);
  };

  const handleCityChange = (selectedOption) => {
    setFormData((prevData) => ({
      ...prevData,
      selectedCity: selectedOption,
    }));
  };

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSave = async () => {
    setIsSpinner(true);
    try {
      const response = await updateUserDetailsRequest({formData, idToken});
      console.log(response, "responseresponse");
      // Example: Check status code or nested data
      if (response?.status === 200 || response?.data?.success) {
        dispatch(returnMessages("Updated successfully. Everything went great. Let's continue.", 200));
        dispatch(getUser(idToken));
        setIsSpinner(false);
        setSuccess(true);
        setLocalEditMode(false);
        setEditMode(false);
      } else {
        throw new Error(response?.data?.message || "Failed to update details");
      }
    } catch (err) {
      setError(err.message || "Failed to save details");
      setIsSpinner(false);
    }
  };

  const handleLogout = () => {
    dispatch(deAuthenticate());
    dispatch(PURGE_Brand());
    clearPersistedData();
    window.location.reload();
  };

  // Determine if field should be permanently disabled
  const isFieldPermanentlyDisabled = (fieldName) => {
    return !!userDetails?.[fieldName]; // Permanently disable if field has a value
  };

  // Determine if field is editable (only applies to fields without initial values)
  const isFieldDisabled = (fieldName) => {
    if (isFieldPermanentlyDisabled(fieldName)) return true; // Always disabled if it has a value
    return !editMode && hasUserDetails; // Otherwise, depends on edit mode
  };

  // Check if there are any editable fields
  const hasEditableFields = Object.keys(formData).some((key) => !isFieldPermanentlyDisabled(key));

  return (
    <>
      <div className="account_details_upper">
        <div
          className="account_details_upper_left"
          style={{width: "100%"}}
        >
          <div className="account_img_wrapper">
            <p className="accountdetails-image_dp">{`${formData?.first_name?.charAt(0)?.toUpperCase() || ""} ${formData?.last_name?.charAt(0)?.toUpperCase() || ""}` || "NA"}</p>
          </div>
          <div className="account_details_upper_content">
            <h4>{`${formData.first_name} ${formData.last_name}` || "NA"}</h4>
            <p>Funded Trader</p>
          </div>
        </div>
        <div className="account_buttons">
          {hasEditableFields && (
            <>
              {editMode && (
                <button
                  className="save_button"
                  onClick={handleSave}
                  disabled={isSpinner}
                >
                  {isSpinner ? "Saving..." : "Save"}
                </button>
              )}

              {hasUserDetails && (
                <button
                  className="edit_button"
                  onClick={handleEditMode}
                >
                  {!editMode&&<svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M12 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V12"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M5.625 2.62523C5.22718 2.2274 4.68761 2.00391 4.125 2.00391C3.56239 2.00391 3.02282 2.2274 2.625 2.62523C2.22718 3.02305 2.00368 3.56262 2.00368 4.12523C2.00368 4.68784 2.22718 5.2274 2.625 5.62523L12 15.0002L16 16.0002L15 12.0002L5.625 2.62523Z"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>}
                  {editMode ? "Cancel" : "Edit"}
                </button>
              )}
            </>
          )}
        </div>
      </div>
      <div className="profileFormWrapper">
        <div className="account_details">
          {error && (
            <ErrorModal
              desc={error}
              setModalOpen={setError}
              btnText="Cancel"
            />
          )}
          <div className="account_details_lower">
            <div className="account_form">
              <form>
                <div className="account_input_container_upper">
                  <div className="account_input">
                    <label
                      htmlFor="firstName"
                      className="label_black"
                    >
                      First Name
                    </label>
                    <div className={`account_input_wrapper ${!isFieldDisabled("first_name") && "editable"}`}>
                      <input
                        className="account_details_input"
                        type="text"
                        value={formData.first_name}
                        placeholder="First Name"
                        name="first_name"
                        onChange={handleChange}
                        disabled={isFieldDisabled("first_name")}
                      />
                    </div>
                  </div>
                  <div className="account_input">
                    <label
                      htmlFor="lastName"
                      className="label_black"
                    >
                      Last Name
                    </label>
                    <div className={`account_input_wrapper ${!isFieldDisabled("last_name") && "editable"}`}>
                      <input
                        className="account_details_input"
                        type="text"
                        placeholder="Last Name"
                        value={formData.last_name}
                        name="last_name"
                        onChange={handleChange}
                        disabled={isFieldDisabled("last_name")}
                      />
                    </div>
                  </div>
                  <div className="account_input">
                    <label
                      htmlFor="contact"
                      className="label_black"
                    >
                      Contact Number
                    </label>
                    <div className={`contactNumber_div ${!isFieldDisabled("contact") && "editable"}`}>
                      <div className="countryCodeDiv">
                        <span className="contactNumber_p">+</span>
                        <input
                          className="contactNumber_input"
                          type="number"
                          value={formData.country_code}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              country_code: e.target.value,
                            }))
                          }
                          disabled={isFieldDisabled("country_code")}
                        />
                      </div>
                      <div className="account_input_wrapper_contact">
                        <input
                          className={`account_details_input ${inputErrors.contact ? "input_error" : ""}`}
                          type="number"
                          value={formData.contact}
                          name="contact"
                          onChange={handleChange}
                          disabled={isFieldDisabled("contact")}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="account_input_container_lower">
                  <div className="account_input">
                    <label
                      htmlFor="email"
                      className="label_black"
                    >
                      Email
                    </label>
                    <div className={`account_input_wrapper ${!isFieldDisabled("email") && "editable"}`}>
                      <input
                        className={`account_details_input ${inputErrors.email ? "input_error" : ""}`}
                        type="text"
                        value={formData.email}
                        name="email"
                        onChange={handleChange}
                        disabled={isFieldDisabled("email")}
                        style={{marginRight: "10px"}}
                      />
                    </div>
                  </div>
                  <div className="account_input country_selector">
                    <label
                      htmlFor="country"
                      className="label_black"
                    >
                      Country
                    </label>
                    <div className={`account_input_wrapper country ${!isFieldDisabled("country") && "editable"}`}>
                      <Select
                        isSearchable={true}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        options={options}
                        styles={customStyles}
                        value={countryName}
                        onChange={handleCountryChange}
                        components={{IndicatorSeparator: () => null}}
                        name="selectedCountry"
                        id="country"
                        isDisabled={isFieldDisabled("country")}
                      />
                    </div>
                  </div>
                  <div className="account_input">
                    <label
                      htmlFor="city"
                      className="label_black"
                    >
                      City
                    </label>
                    <div className={`account_input_wrapper ${!isFieldDisabled("city") && "editable"}`}>
                      <input
                        className={`account_details_input ${inputErrors.city ? "input_error" : ""}`}
                        type="text"
                        name="city"
                        value={formData.city}
                        placeholder="City"
                        onChange={handleChange}
                        disabled={isFieldDisabled("city")}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="profileline"></div>
        <AccountPassword handleLogout={handleLogout} />
      </div>
    </>
  );
}

export default AccountDetails;
